import _ from 'underscore';

export default class OfferStockItemPriceDialog {
  constructor($scope, OfferService) {
    $scope.$on('open_item_price_dialog', function(event, args) {
      $scope.item = args.item;
      $scope.open_dialog();
    });

    $scope.open_dialog = function() {
      $scope.item_ospp_price = null;
      $scope.item_ospp_incoterm = 3;
      window.openFancyboxDialog('div#item_price_dialog');
    };

    $scope.submit_item_ospp_price = function() {
      if ($scope.item_ospp_price && $scope.item_ospp_price > 0) {
        $scope.applying_ospp_price = true;
        OfferService.submit_ospp_price(window.offer_id, [$scope.item.id], window.user_id, $scope.filter.buyer_country_id, $scope.item_ospp_price, $scope.item_ospp_incoterm).then(function() {
          OfferService.get_matched_item(window.offer_id, window.user_id, $scope.filter, true, $scope.item.id).then(function(data) {
            $scope.item = data.items[0];
            var index = _.indexOf($scope.items, _.findWhere($scope.items, {
              id: $scope.item.id
            }));
            $scope.items[index] = data.items[0];
            $scope.applying_ospp_price = false;
          });
        });
      }
    };

    $scope.init = function() {
      $scope.item_ospp_incoterms = [
        {
          id: 3,
          name: 'FCA'
        },
        {
          id: 1,
          name: 'CFR'
        },
        {
          id: 2,
          name: 'DAP'
        },
      ];
    };

    $scope.init();
  }
}

OfferStockItemPriceDialog.$inject = ['$scope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-stock-item-price-dialog.ctrl.js